// Styles
import FXRatesContainer from "./FXRates.styles";
import Tabs from "../../../../components/Common/Tabs/Tabs";
import ReportsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import AlertsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/AlertsTab/AlertsTab";
import ChangeLogTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ChangeLogTab/ChangeLogTab";

interface FXRatesProps {}

const FXRates = ({}: FXRatesProps) => {
    return (
        <FXRatesContainer>
            <p className={"sectionTitle"}>FX RATES</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="a516eb6c-4798-4284-a7b2-a122cf5d5b9b" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128" />,
                    },
                ]}
            />
        </FXRatesContainer>
    );
};

export default FXRates;
